import classNames from "classnames";
import { HTMLProps, PropsWithChildren } from "react";
import styles from "./button.module.scss";

type Props = PropsWithChildren<{
  className?: string;
  iconClassName?: string;
  type?: "outline" | "danger";
  onClick?: () => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  icon?: any;
  buttonType?: "button" | "submit" | "reset";
}> &
  HTMLProps<HTMLButtonElement>;

export const Button = ({
  children,
  type,
  className,
  iconClassName,
  onClick,
  icon: Icon,
  buttonType,
  ...buttonProps
}: Props) => {
  return (
    <button
      {...buttonProps}
      type={buttonType}
      onClick={onClick}
      className={classNames(
        styles.button,
        type && styles[type],
        Icon && styles.buttonIcon,
        typeof children === "undefined" && styles.buttonWithoutText,
        className
      )}
    >
      {Icon && type === "outline" && (
        <div
          className={classNames(
            styles.icon,
            typeof children === "undefined" && styles.iconWithoutText,
            iconClassName
          )}
        >
          <Icon />
        </div>
      )}
      {children}
      {Icon && type !== "outline" && (
        <div
          className={classNames(
            styles.icon,
            typeof children === "undefined" && styles.iconWithoutText,
            iconClassName,
          )}
        >
          <Icon />
        </div>
      )}
    </button>
  );
};

type MiniButtonProps = Omit<
  Props,
  "buttonType" | "icon" | "type" | "iconClassName"
> & {
  active?: boolean;
};

export const MiniButton = ({
  children,
  className,
  onClick,
  active,
  ...buttonProps
}: MiniButtonProps) => {
  return (
    <button
      {...buttonProps}
      onClick={onClick}
      className={classNames(
        styles.miniButton,
        active && styles.active,
        className
      )}
    >
      {children}
    </button>
  );
};

type LinkProps = PropsWithChildren<
  React.AnchorHTMLAttributes<HTMLAnchorElement>
>;

export const Link = ({ children, className, onClick }: LinkProps) => {
  return (
    <a onClick={onClick} className={classNames(styles.link, className)}>
      {children}
    </a>
  );
};
